import { Query } from 'react-apollo';
import React, { Fragment, useState } from 'react';
import styled from 'react-emotion';
import ReactModal from 'react-modal';
import BindingsQuery from './BindingsQuery.gql';
import { ReactComponent as Cross } from '../../../svg/Cross.svg';
import { theme } from '../../Theme';
import { ProductCard } from '../../CategoryPage/ProductCard';
import { Favourite } from '../../ProductList/Favourite';
import { Link } from 'react-router-dom';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import PackageCard from './PackageCard';

const InfoModalWrapper = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalInside = styled('div')`
  position: absolute;
  top: 190px;
  left: 0;
  right: 0;
  background: #fff;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  border: 5px solid #000;
  z-index: 100;

  svg.close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 20px;
    height: 20px;
    color: black;
    use,
    g,
    path {
      fill: black;
    }
  }

  font-family: ${({ theme }) => theme.fonts.primary};

  p {
    margin-bottom: 1rem;
  }
  p a,
  p a:visited {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }

  h2,
  h3,
  h4 {
    text-align: left;
  }

  h2,
  h3,
  h4,
  strong,
  b {
    font-family: ${({ theme }) => theme.fonts.primary};
    text-transform: uppercase;
    letter-spacing: 0.08rem;
  }
  h2 {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    ${({ theme }) => theme.below.lg} {
      font-size: 1rem;
    }
  }
  strong,
  b {
    font-weight: bold;
  }

  &:after {
    display: none;
  }
  img {
    max-width: 100%;
  }

  table {
    width: 100%;
    text-align: left;
    margin-bottom: 40px;
    p {
      margin: 0;
    }
    tr {
      background: #f3f3f3;
      &:nth-child(even) {
        background: white;
      }
      &:first-of-type {
        font-weight: 600;
      }
      th {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 12px;
        }
      }
      td {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 11px;
        }
      }
      td:first-of-type {
        width: 20%;
      }
    }
  }

  .see-more {
    display: flex;
    justify-content: center;
  }

  ${({ theme }) => theme.below.md} {
    top: unset;
    bottom: 0;
    padding: 1rem;
  }
`;

const InfoLink = styled('button')`
  background: transparent;
  text-align: right;
  text-decoration: underline;
  font-size: 12px;
`;

const Title = styled('h2')`
  /* padding-top: 2rem; */
  margin-bottom: 5px;

  ${({ theme }) => theme.below.md} {
    font-size: 18px !important;
    margin-bottom: 10px !important;
  }
`;

const Text = styled('p')`
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 148.187%; /* 20.746px */
  max-width: 90%;

  ${({ theme }) => theme.below.md} {
    font-size: 12px;
    max-width: 100%;
  }
`;

const BindingsNavigationWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;

  ${({ theme }) => theme.below.md} {
    flex-wrap: wrap;
  }
`;

const ProductGrid = styled('div')`
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .product-card {
    max-width: 18%;

    h3 {
      font-size: 12px;
    }
  }
`;

const StyledButton = styled('button')`
  color: #000;
  background: #f3f3f3;
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  line-height: 24px;
  padding: 0 1rem;
  width: auto;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-top: 10px;
  margin-right: 10px;

  a {
    text-decoration: none;
    color: #000;
  }

  &.active {
    background: ${(props) =>
      props.active ? theme.colors.black : theme.colors.skiAccent};
    color: #fff;
    font-weight: 700;
    a {
      color: #fff;
    }
  }
  svg {
    margin-right: 0.5rem;
  }

  &.out-of-stock {
    color: #b3b3b3;
    text-decoration: line-through;
  }
`;

const BindingsNavigation = ({ bindingsID, setBindingsID }) => {
  return (
    <Query query={BindingsQuery} variables={{ id: 159 }}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return `Error!: ${error}`;
        if (data.category) {
          if (bindingsID === '')
            setBindingsID(data?.category?.subcategories[0]);
          return (
            <BindingsNavigationWrapper>
              {data?.category?.subcategories?.map((subcategory, index) => {
                return (
                  <>
                    {subcategory?.id === 166 ||
                    subcategory?.id === 167 ? null : (
                      <>
                        <Above breakpoint="md">
                          {(matches) =>
                            matches ? (
                              <>
                                <StyledButton
                                  className={
                                    bindingsID?.id === subcategory?.id &&
                                    'active'
                                  }
                                  onClick={() => {
                                    setBindingsID(subcategory);
                                  }}
                                >
                                  {subcategory?.name}
                                </StyledButton>
                              </>
                            ) : (
                              <StyledButton className={'active'}>
                                <Link to={subcategory?.primaryRoute?.path}>
                                  {subcategory?.name}
                                </Link>
                              </StyledButton>
                            )
                          }
                        </Above>
                      </>
                    )}
                  </>
                );
              })}
            </BindingsNavigationWrapper>
          );
        }
      }}
    </Query>
  );
};

const BindingsContent = (props) => {
  return (
    <Query query={BindingsQuery} variables={{ id: props.bindingsID?.id }}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return `Error!: ${error}`;
        if (data.category) {
          return (
            <ProductGrid>
              {data?.category?.products?.result?.map((product, index) => {
                return (
                  <ProductCard
                    key={index + ':' + product?.articleNumber}
                    product={product}
                    style={{ opacity: loading ? 0.5 : 1 }}
                    bindings={true}
                  >
                    <Favourite
                      product={product}
                      style={{
                        position: 'absolute',
                        padding: '0.5em',
                        fontSize: '1.5em',
                        top: 0,
                        right: '0.5em',
                      }}
                    />
                  </ProductCard>
                );
              })}
            </ProductGrid>
          );
        }
      }}
    </Query>
  );
};

const Bindings = (props) => {
  const [open, setOpen] = useState(false);
  const [bindingsID, setBindingsID] = useState('');

  return (
    <Fragment>
      <InfoLink
        className={`modalLink ${props.type && props.type}`}
        onClick={() => {
          setOpen(true);
        }}
      >
        {props.link && props.link}
        {props.children && props.children}
      </InfoLink>
      <InfoModalWrapper
        isOpen={open}
        onRequestClose={() => {
          setOpen(false);
        }}
      >
        <ModalInside className="modal-inside">
          <Cross
            className="close-icon"
            onClick={() => {
              setOpen(false);
            }}
          />
          <Title>Välja annan binding?</Title>
          <Text>
          Hittar du inte vad du söker bland våra rekommenderade bindningar? 
          Då kan du skapa ditt eget paket med vilken bindning du vill. 
          Har du några funderingar på vilken bindning du ska välja är du 
          välkommen att kontakta oss med dina frågor. Oavsett vilken bindning 
          du väljer får du paketpris ihop med skidan du köper.{' '}
          </Text>

          <Above breakpoint="md">
            {(matches) =>
              matches ? (
                <>
                  <BindingsNavigation
                    bindingsID={bindingsID}
                    setBindingsID={setBindingsID}
                  />
                  <BindingsContent
                    bindingsID={bindingsID}
                    product={props.product}
                    packageHandler={props?.packageHandler}
                    selectedPackage={props?.selectedPackage}
                  />
                  <div className="see-more">
                    <StyledButton className="active">
                      <Link to={bindingsID?.primaryRoute?.path}>
                        Se fler bindningar
                      </Link>
                    </StyledButton>
                  </div>
                </>
              ) : (
                <BindingsNavigation
                  bindingsID={bindingsID}
                  setBindingsID={setBindingsID}
                />
              )
            }
          </Above>

          {props.Component && <props.Component {...props} />}
        </ModalInside>
      </InfoModalWrapper>
    </Fragment>
  );
};

export default Bindings;
